/** Roue de chargement générique — voir `.tp-spinner` dans operator-ui.css. */
export function Spinner({ className = '' }: { className?: string }) {
  return <span className={`tp-spinner ${className}`.trim()} aria-hidden="true" />
}

/** Bloc "Chargement…" standard : roue + libellé, centrés. */
export function LoadingState({ label = 'Chargement…', className = '' }: { label?: string; className?: string }) {
  return (
    <span className={`tp-loading-state ${className}`.trim()} role="status" aria-live="polite">
      <Spinner />
      {label}
    </span>
  )
}
